<main>
    <div id="card-config">
        <div class="head">
          <h1>Produtos</h1> 
          <div class="linha">
            <span>lista de todos os seus produtos</span>
            <button class="btn-nav" routerLink="../produtos/cadastro"><img src="../../assets/logo-removebg-preview.png"> Novo produto </button>
          </div> 
        </div>
        <table class="table">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Produto</th>
                <th scope="col">Status</th>
                <th scope="col">Ações</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr [class.red]="produto.bl_status == 0" *ngFor="let produto of produtos | paginate: { currentPage: page, itemsPerPage: pageSize, totalItems: count}">
                <td scope="row">{{produto.sr_id}}</td>
                <td>{{ produto.vc_nome }}</td>
                <td>{{ produto.bl_status == 1 ? 'Ativo' : 'Inativo' }}</td>
                <td>
                    <button class="btn-nav" routerLink="../produtos/atualizar/{{produto.sr_id}}" routerLinkActive="router-link-active" > <mat-icon class="material-icons-sharp">
                      edit
                      </mat-icon>Editar</button>
                </td>
                <td>
                  
                  <button (click)="finalizar(produto)" class="btn-nav"> <mat-icon class="material-icons-sharp del">
                    delete_forever
                    </mat-icon>Ativa/Desativar</button>
                </td>
              </tr>
            </tbody>
            <pagination-controls class="pagination" (pageChange)="mudarPagina($event)" previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
          </table>
      </div>
</main>